import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import moment from "moment";
import { UserService } from "../../domain/user-service";
import { Logger } from "../../infrastructure/logger";
import { ExportPlatformsComponent } from "../export-platforms/export-platforms";
import { ExportConfiguration } from "../../domain/export-configuration";
import { ShowRepository } from "../../domain/show-repository";
import { environment } from "app/environments/environment";

@Component({
  selector: "icn-export-epg",
  templateUrl: "./export-epg.html",
  styleUrls: ["./export-epg.scss"],
})
export class ExportEpgComponent implements OnInit {
  constructor(
    private userService: UserService,
    private showRepository: ShowRepository,
    private logger: Logger,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  @ViewChild(ExportPlatformsComponent) exportPlatform: ExportPlatformsComponent;

  channelIdForExport = 0;
  endpoint: string;
  channelNameForExport: string;
  exportConfigurations: ExportConfiguration[];

  exportConfigurationChosen: ExportConfiguration;
  exportFormat = "csv";

  startDate: moment.Moment;

  endDate: moment.Moment;

  minDuration = 5;

  ngOnInit() {
    this.endpoint = environment.ENDPOINT + "/api/";
    this.userService.getCurrentChannel().then((channel) => {
      if (channel) {
        if (channel.id) {
          this.channelIdForExport = channel.id;
        }
        this.channelNameForExport = channel.name;
      }
    });
    this.showRepository.getExportConfigurations().then((response) => {
      this.exportConfigurations = response;
      if (this.exportConfigurations.length > 0) {
        this.exportConfigurationChosen = this.exportConfigurations[0];
      }
    });
  }

  exportEpg() {
    if (
      this.startDate &&
      this.endDate &&
      (this.exportFormat === "xml" || !!this.exportConfigurationChosen)
    ) {
      this.showRepository
        .exportEpg(
          this.channelIdForExport,
          this.startDate,
          this.endDate,
          this.minDuration,
          this.channelNameForExport,
          this.exportConfigurationChosen?.id ?? -1,
          this.exportFormat,
        )
        .catch((err) => {
          this.logger.error("Could not export epg. Error: " + err);
        });
    }
  }

  changeStartDate(val) {
    this.startDate = val;
  }

  changeEndDate(val) {
    this.endDate = val;
  }

  onClickAddPlatform(values, platformsPopover) {
    this.exportPlatform.exportConfiguration = new ExportConfiguration(
      undefined,
      undefined,
      [],
    );
    this.exportPlatform.addOrEdit = "Add";
    platformsPopover.show(values);
    this.changeDetectorRef.markForCheck();
  }

  onPlatformsClose(platformsPopover) {
    platformsPopover.hide();
  }

  onSelectedExportConfigurationChange(val, platformsPopover) {
    this.exportConfigurationChosen = val;

    this.exportPlatform.exportConfiguration = new ExportConfiguration(
      val.id,
      val.name,
      val.headers.slice(0),
    );
    this.exportPlatform.addOrEdit = "Edit";

    platformsPopover.show(val);
    this.changeDetectorRef.markForCheck();
  }

  onAddedExportConfiguration(
    exportConfiguration: ExportConfiguration,
    platformsPopover,
  ) {
    this.exportConfigurationChosen = exportConfiguration;
    this.exportConfigurations.push(exportConfiguration);
    platformsPopover.hide();
    this.changeDetectorRef.markForCheck();
  }

  onUpdatedExportConfiguration(
    exportConfiguration: ExportConfiguration,
    platformsPopover,
  ) {
    const index = this.exportConfigurations.findIndex(
      (x) => x.id === exportConfiguration.id,
    );
    this.exportConfigurations.splice(index, 1, exportConfiguration);
    this.exportConfigurationChosen = exportConfiguration;
    platformsPopover.hide();
    this.changeDetectorRef.markForCheck();
  }

  onXMLCheckboxCheck(isChecked: boolean) {
    this.exportFormat = isChecked ? "xml" : "csv";
  }
}
